import React, { Component } from 'react'
import Error from 'auth/Error'
import { Event } from 'components/Event'

class ErrorCatcher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isError: false
    };
  }
  
  componentDidCatch(error, info) {
    console.log("WOAH!!!");
    Event("ERROR",true,error.toString() + ":::" + info.toString());
    this.setState({isError: true});
  }

  render() {
    if (this.state.isError) {
      return (
        <Error {...this.props}/>
      );
    }
    return this.props.children;
  }
}

export default ErrorCatcher;

export const ErrorWrapper = WrappedComponent => props => (
  <ErrorCatcher {...props}>
    <WrappedComponent {...props} />
  </ErrorCatcher>
);
